import * as React from "react";
import { styled } from "@mui/material";
import { PredefinedInsight } from "../graphql/types/graphql";
import { PatientSummary } from "./PatientSummary";
import { PatientCardAnswerPrompt } from "fe-web-components/patientCard/patientCardAnswerPrompt";
import { MedicalDataDisplayTabs } from "fe-web-components/patientCard/MedicalDataDisplayTabs";

import { SessionInsights } from "../types/types";

//region [[ Styles ]]

const InsightsDisplayView = styled("div")({
  backgroundColor: "#FFFFFF",
  height: 500,
  width: "100%",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface InsightsDisplayProps {
  insights?: SessionInsights;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InsightsDisplay = ({ insights }: InsightsDisplayProps) => {
  return (
    insights && (
      <InsightsDisplayView>
        <MedicalDataDisplayTabs
          error={null}
          showInsights={true}
          loading={false}
          summarySection={
            <div
              style={{
                padding: 10,
                display: "flex",
                flexDirection: "column",
                gap: 14,
                alignItems: "flex-end",
              }}
            >
              <PatientSummary />
            </div>
          }
          assessmentSection={
            <PatientCardAnswerPrompt
              questionType={PredefinedInsight.Assessment}
            />
          }
          ddSection={
            <PatientCardAnswerPrompt questionType={PredefinedInsight.Dd} />
          }
          workupSection={
            <PatientCardAnswerPrompt questionType={PredefinedInsight.Plan} />
          }
          showDD={true}
        />
      </InsightsDisplayView>
    )
  );
};
